import { checkInOnDemandBookingPressedAction } from './actions';

export const GET_NEXT_BOOKING_STEP = 'GET_NEXT_BOOKING_STEP';
export const SET_WORKOUT_SESSION = 'SET_WORKOUT_SESSION';
export const SET_INVITES = 'SET_INVITES';
export const SET_PARTNER_PROFILES = 'SET_PARTNER_PROFILES';
export const SET_WAITLIST_ENTRY = 'SET_WAITLIST_ENTRY';
export const FETCH_PARTNER_PROFILES_REQUEST = 'FETCH_PARTNER_PROFILES_REQUEST';
export const FETCH_PARTNER_PROFILES_SUCCESS = 'FETCH_PARTNER_PROFILES_SUCCESS';
export const FETCH_PARTNER_PROFILES_FAILED = 'FETCH_PARTNER_PROFILES_FAILED';
export const RESET_WIZARD = 'RESET_WIZARD';
export const SET_LONG_TERM_GOAL = 'SET_LONG_TERM_GOAL';
export const SET_SELECTED_GYM = 'SET_SELECTED_GYM';
export const GET_CLASS_LIST_REQUEST = 'GET_CLASS_LIST_REQUEST';
export const GET_CLASS_LIST_SUCCESS = 'GET_CLASS_LIST_SUCCESS';
export const GET_CLASS_LIST_FAILURE = 'GET_CLASS_LIST_FAILURE';
export const GET_PREVIOUS_BOOKING_STEP = 'GET_PREVIOUS_BOOKING_STEP';
export const SET_SOLO_WORKOUT = 'SET_SOLO_WORKOUT';
export const CLEAR_LOADED_SLOTS = 'CLEAR_LOADED_SLOTS';
export const GET_BOOKING_SLOTS_REQUEST = 'GET_BOOKING_SLOTS_REQUEST';
export const GET_HOME_BOOKING_SLOTS_SUCCESS = 'GET_HOME_BOOKING_SLOTS_SUCCESS';
export const GET_STUDIO_BOOKING_SLOTS_SUCCESS = 'GET_STUDIO_BOOKING_SLOTS_SUCCESS';
export const GET_BOOKING_SLOTS_FAILURE = 'GET_BOOKING_SLOTS_FAILURE';
export const SET_PENDING_SLOT = 'SET_PENDING_SLOT';
export const SET_DURATION = 'SET_DURATION';
export const MAKE_BOOKING_REQUEST = 'book_home_summary_confirm';
export const MAKE_BOOKING_SUCCESS = 'MAKE_BOOKING_SUCCESS';
export const MAKE_BOOKING_FAILURE = 'MAKE_BOOKING_FAILURE';
export const GET_RECOMMENDED_SETTINGS_REQUEST = 'GET_RECOMMENDED_SETTINGS_REQUEST';
export const GET_RECOMMENDED_SETTINGS_SUCCESS = 'GET_RECOMMENDED_SETTINGS_SUCCESS';
export const UPDATE_SETTINGS = 'UPDATE_SETTINGS';
export const GET_RECOMMENDED_SETTINGS_FAILURE = 'GET_RECOMMENDED_SETTINGS_FAILURE';
export const CHANGE_BOOKING_REQUEST = 'CHANGE_BOOKING_REQUEST';
export const CHANGE_BOOKING_SUCCESS = 'CHANGE_BOOKING_SUCCESS';
export const CHANGE_BOOKING_FAILURE = 'CHANGE_BOOKING_FAILURE';
export const SELECT_SKILL_LEVEL_REQUEST = 'SELECT_SKILL_LEVEL_REQUEST';
export const SELECT_SKILL_LEVEL_SUCCESS = 'SELECT_SKILL_LEVEL_SUCCESS';
export const SELECT_SKILL_LEVEL_FAILURE = 'SELECT_SKILL_LEVEL_FAILURE';
export const OPEN_PERSONALISE_WORKOUT_SETUP_SCREEN = 'OPEN_PERSONALISE_WORKOUT_SETUP_SCREEN';
export const CLEAR_PERSONALISE_SETUP_WARNING = 'CLEAR_PERSONALISE_SETUP_WARNING';
export const SELECT_STUDIO_PARTNER = 'SELECT_STUDIO_PARTNER';
export const SET_IS_CUSTOMISING_WORKOUT = 'SET_IS_CUSTOMISING_WORKOUT';
export const WORKOUT_JOIN = 'workout_join';
export const START_BOOKING_FROM_WORKOUTS = 'book_start_from_workouts';
export const CUSTOMISE_BOOKINGS_SETTINGS_REQUEST = 'book_home_summary_customise_request';
export const ACCEPT_WORKOUT_SETTINGS_CHANGE = 'workout_settings_customise_accept';
export const SHARE_BOOKING_INVITE = 'book_home_invite_share';
export const SKIP_BOOKING_INVITE = 'book_home_invite_skip';
export const BOOKING_INVITE_CONTINUE = 'book_home_invite_continue';
export const ACCEPT_INVITE = 'ACCEPT_INVITE';
export const SUBMIT_WORKOUT_RATING = 'workouts_embedded_rate';
export const CANCEL_BOOKING_REQUEST = 'workouts_workout_booking_cancel_request';
export const CANCEL_BOOKING_CONFIRMED = 'workouts_workout_booking_cancel_confirm';
export const OPEN_WORKOUT_HISTORY = 'workouts_workout_history_open';
export const OPEN_EXISTING_BOOKINGS_VIEW = 'workouts_workout_booking_view';
export const SETUP_INSTANT_WORKOUT = 'setup_instant_workout';
export const SET_DAY_TEMP = 'set_day_temp';
export const BOOKING_MODAL_VISIBLE = 'bookings_modal_visible';
export const DATE_TIME_SELECTED = 'DATE_TIME_SELECTED';

export const ENABLE_MIRROR_PERMISSION_PRESSED = 'ENABLE_MIRROR_PERMISSION_PRESSED';
export const SETUP_MIRROR_LATER_PRESSED = 'SETUP_MIRROR_LATER_PRESSED';

export const SETUP_LEADERBOARD_NEXT_PRESSED = 'SETUP_LEADERBOARD_NEXT_PRESSED';

export const SETUP_HR_MONITOR_NEXT_PRESSED = 'SETUP_HR_MONITOR_NEXT_PRESSED';
export const SETUP_HR_MONITOR_VIEW_SUPPORTED_DEVICES_PRESSED = 'SETUP_HR_MONITOR_VIEW_SUPPORTED_DEVICES_PRESSED';
export const SETUP_HR_MONITOR_VIEW_SUPPORTED_DEVICES_CLOSED = 'SETUP_HR_MONITOR_VIEW_SUPPORTED_DEVICES_CLOSED';

export const CONNECT_APPLE_HEALTH_KIT_SKIP_PRESSED = 'CONNECT_APPLE_HEALTH_KIT_SKIP_PRESSED';
export const CONNECT_APPLE_HEALTH_KIT_NEXT_PRESSED = 'CONNECT_APPLE_HEALTH_KIT_NEXT_PRESSED';

export const SETUP_DEFAULT_HOME_EQUIPMENT_NEXT_PRESSED = 'SETUP_DEFAULT_HOME_EQUIPMENT_NEXT_PRESSED';

export const CLOSE_FEATURE_DEMO_SCREEN_REQUEST = 'SETUP_MIRROR_CLOSE_PRESSED_REQUEST';
export const CLOSE_FEATURE_DEMO_SCREEN_SUCCESS = 'SETUP_MIRROR_CLOSE_PRESSED_SUCCESS';
export const CLOSE_FEATURE_DEMO_SCREEN_FAILURE = 'SETUP_MIRROR_CLOSE_PRESSED_FAILURE';

export const CREATE_DEMO_STUDIO_SCREEN_OPENED_REQUEST = 'CREATE_DEMO_STUDIO_SCREEN_OPENED_REQUEST';
export const CREATE_DEMO_STUDIO_SCREEN_OPENED_SUCCESS = 'CREATE_DEMO_STUDIO_SCREEN_OPENED_SUCCESS';
export const CREATE_DEMO_STUDIO_SCREEN_OPENED_FAILURE = 'CREATE_DEMO_STUDIO_SCREEN_OPENED_FAILURE';

export const CLOSE_DEMO_BOOKING_SUMMARY_SCREEN = 'CLOSE_DEMO_BOOKING_SUMMARY_SCREEN';

export const CREATE_DEMO_STUDIO_BOOKING_REQUEST = 'CREATE_DEMO_STUDIO_BOOKING_REQUEST';
export const CREATE_DEMO_STUDIO_BOOKING_SUCCESS = 'CREATE_DEMO_STUDIO_BOOKING_SUCCESS';
export const CREATE_DEMO_STUDIO_BOOKING_FAILURE = 'CREATE_DEMO_STUDIO_BOOKING_FAILURE';
export const SETUP_APP_PRESSED = 'SETUP_APP_PRESSED';
export const SETUP_APP_PRESSED_SUCCESS = 'SETUP_APP_PRESSED_SUCCESS';

export const CHECKIN_REQUEST = 'CHECKIN_REQUEST';
export const CHECKIN_SUCCESS = 'CHECKIN_SUCCESS';
export const CHECKIN_FAILURE = 'CHECKIN_FAILURE';

export const WAITINGLIST_REQUEST = 'WAITINGLIST_REQUEST';
export const WAITINGLIST_SUCCESS = 'WAITINGLIST_SUCCESS';
export const WAITINGLIST_FAILURE = 'WAITINGLIST_FAILURE';

export const WAITINGLIST_BOOKING_REQUEST = 'WAITINGLIST_BOOKING_REQUEST';
export const WAITINGLIST_BOOKING_SUCCESS = 'WAITINGLIST_BOOKING_SUCCESS';
export const WAITINGLIST_BOOKING_FAILURE = 'WAITINGLIST_BOOKING_FAILURE';

export const REMOVE_WAITLIST_ENTRY = 'REMOVE_WAITLIST_ENTRY';
export const CHANGE_WAITLIST_ENTRY = 'CHANGE_WAITLIST_ENTRY';
export const CONFIRM_REMOVE_WAITLIST_ENTRY = 'CONFIRM_REMOVE_WAITLIST_ENTRY';

export const START_WORKOUT_NOW_REQUEST = 'START_WORKOUT_NOW_REQUEST';
export const START_WORKOUT_NOW_SUCCESS = 'START_WORKOUT_NOW_SUCCESS';
export const START_WORKOUT_NOW_FAILURE = 'START_WORKOUT_NOW_FAILURE';

export const SCHEDULE_OR_START_WORKOUT_BUTTON_PRESSED = 'SCHEDULE_OR_START_WORKOUT_BUTTON_PRESSED';

export const BOOK_WORKOUT_SLIDER_CARD_PRESSED = 'BOOK_WORKOUT_SLIDER_CARD_PRESSED';
export const WORKOUT_BOOKING_SLIDER_CARD_PRESSED = 'WORKOUT_BOOKING_SLIDER_CARD_PRESSED';
export const WAITLIST_SLIDER_CARD_PRESSED = 'WAITLIST_SLIDER_CARD_PRESSED';

export const CONTINUE_DEMO_BOOKING_PRESSED = 'CONTINUE_DEMO_BOOKING_PRESSED';
export const LIVE_STREAM_OPTIONS_NEXT_PRESSED = 'LIVE_STREAM_OPTIONS_NEXT_PRESSED';
export const LIVE_STREAM_OPTION_TOGGLED = 'LIVE_STREAM_OPTION_TOGGLED';
export const PRE_WARMUP_TALK_TIME_OPTION_TOGGLED = 'PRE_WARMUP_TALK_TIME_OPTION_TOGGLED';
export const WILL_DROP_OFF_AFTER_TALK_TOGGLED = 'WILL_DROP_OFF_AFTER_TALK_TOGGLED';

export const WORKOUT_TYPE_SELECTED_IN_BOOKING_STEP = 'WORKOUT_TYPE_SELECTED_IN_BOOKING_STEP';

export const START_ON_DEMAND_STUDIO_BOOKING_REQUEST = 'START_ON_DEMAND_STUDIO_BOOKING_REQUEST';
export const START_ON_DEMAND_STUDIO_BOOKING_SUCCESS = 'START_ON_DEMAND_STUDIO_BOOKING_SUCCESS';
export const START_ON_DEMAND_STUDIO_BOOKING_FAILED = 'START_ON_DEMAND_STUDIO_BOOKING_FAILED';

export const ON_DEMAND_STUDIO_SELECT_SLOT_BACK_PRESSED = 'ON_DEMAND_STUDIO_SELECT_SLOT_BACK_PRESSED';

export const CHECK_IN_ON_DEMAND_BOOKING_PRESS_REQUEST = 'CHECK_IN_ON_DEMAND_BOOKING_PRESS_REQUEST';
export const CHECK_IN_ON_DEMAND_BOOKING_PRESS_SUCCESS = 'CHECK_IN_ON_DEMAND_BOOKING_PRESS_SUCCESS';
export const CHECK_IN_ON_DEMAND_BOOKING_PRESS_FAILURE = 'CHECK_IN_ON_DEMAND_BOOKING_PRESS_FAILURE';

export const UPDATING_BOXING_SETTINGS_DURING_CHECKIN_REQUEST = 'UPDATING_BOXING_SETTINGS_DURING_CHECKIN_REQUEST';
export const UPDATING_BOXING_SETTINGS_DURING_CHECKIN_SUCCESS = 'UPDATING_BOXING_SETTINGS_DURING_CHECKIN_SUCCESS';
export const UPDATING_BOXING_SETTINGS_DURING_CHECKIN_FAILURE = 'UPDATING_BOXING_SETTINGS_DURING_CHECKIN_FAILURE';

export const UPGRADE_STUDIO_PLAN_PRESSED = 'UPGRADE_STUDIO_PLAN_PRESSED';
export const UPGRADE_STUDIO_PLAN_PRESSED_SUCCESS = 'UPGRADE_STUDIO_PLAN_PRESSED_SUCCESS';
export const UPGRADE_STUDIO_PLAN_PRESSED_FAILED = 'UPGRADE_STUDIO_PLAN_PRESSED_FAILED';
